module.exports = __webpack_public_path__ + "static/img/slide_1_fr.a912782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/slider/slide_1_fr.png
// module id = vopL
// module chunks = 0